import { HostListener, Injectable, OnDestroy } from '@angular/core';
import { BehaviorSubject, iif, Observable, of } from 'rxjs';
import { delay, distinctUntilChanged, filter, map, pairwise, switchMap, tap } from 'rxjs/operators';
import { FreezeScrollOnDocumentService } from 'src/core-lib/misselaineous/freeze-scroll-on-document.service';
import { Guard } from 'src/core-lib/misselaineous/guards';
import { Overlay } from '../models/overlay.interface';



@Injectable({
    providedIn: 'root'
})
export class OverlayService implements OnDestroy {
    private overlay: BehaviorSubject<Overlay<any>> = new BehaviorSubject<Overlay<any>>(null);

    public readonly overlay$: Observable<Overlay<any>> = this.overlay.pipe(
        switchMap(overlay =>
            iif(() => Guard.is.nullOrUndefined(overlay),
                of(overlay).pipe(delay(112)),
                of(overlay).pipe(delay(225))
            )),
        distinctUntilChanged(),
        tap(overlay => this.handleBackground(overlay))
    );

    public readonly overlayCloses$: Observable<void> = this.overlay.pipe(
        pairwise(),
        filter(([a, b]) => Guard.not.null(a) && Guard.is.null(b)),
        map(() => undefined)
    );

    public readonly overlayOpens$: Observable<Overlay<any>> = this.overlay.pipe(
        pairwise(),
        filter(([a, b]) => Guard.is.null(a) && Guard.not.null(b)),
        map(([a, b]) => b)
    );

    constructor(
        private freezeScrollOnDocumentService: FreezeScrollOnDocumentService
    ) {
        window.addEventListener('overlay', this.eventFn());
    }
    eventFn(): EventListenerOrEventListenerObject {
        return (_: CustomEvent<Overlay<unknown>>) => this.open(_.detail);
    }
    ngOnDestroy(): void {
        window.removeEventListener('overlay', this.eventFn());
    }


    open<T>(overlay: Overlay<T>): void {
        this.overlay.next(overlay);
    }

    close(): void {
        this.overlay.next(null);
    }

    current(): Overlay<any> {
        return this.overlay.getValue();
    }

    private handleBackground(overlay: Overlay<any>): void {
        if (Guard.is.null(overlay)) {
            this.freezeScrollOnDocumentService.unfreezeDocument();
        } else {
            this.freezeScrollOnDocumentService.freezeDocument();
        }
    }
}
